import { DashboardChart } from "@tellescope/ui";
import { DashboardMessagesContainer } from "./components/DashboardMessagesContainer";
import { DashboardTicketsContainer } from "./components/DashboardTicketsContainer";
import { CallQueuesPanel } from "../../components/dashboard/call-queues/CallQueuesPanel";
import { useDashboardChartData } from "./hooks/useDashboardChartData";
import { DEFAULT_DASHBOARD_CONFIGURATION, useShallowDashboardConfigurationStore } from "../../store";
import { useAuth } from "@tellescope/tanstack-query";
import { useTranslation } from "react-i18next";
import { TicketQueuesPanel } from "../../components/dashboard";

export const DashboardPage: React.FC = () => {
  const { t } = useTranslation("common");
  const { currentUser } = useAuth();
  const { userConfigurations } = useShallowDashboardConfigurationStore("userConfigurations");
  const preferences = userConfigurations[currentUser.id] ?? DEFAULT_DASHBOARD_CONFIGURATION;
  const chartData = useDashboardChartData();

  if (!currentUser) {
    return <div>{t("Loading...")}</div>;
  }

  return (
    <div className="space-y-6">
      {/* Analytics Chart - always full width */}
      {preferences.showAnalytics && (
        <DashboardChart
          messageChartData={chartData.messageChartData}
          ticketChartData={chartData.ticketChartData}
          contactChartData={chartData.contactChartData}
        />
      )}

      {/* Dashboard panels - flexible grid, max 2 per row */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 xl:[&>*:last-child:nth-child(odd)]:col-span-2">
        {preferences.showMessages && <DashboardMessagesContainer />}
        {preferences.showTickets && <DashboardTicketsContainer />}
        {preferences.showCallHoldQueues && <CallQueuesPanel />}
        {preferences.showTicketQueues && <TicketQueuesPanel />}
      </div>

      {/* Recent Activity Card */}
      {/* {preferences.showRecentActivity && <RecentActivityCard />} */}
    </div>
  );
};
